module.exports = __webpack_public_path__ + "img/head.3b21d187.png";